import { useNavigate } from 'react-router-dom'
import { Box, Typography, Button, Paper } from '@mui/material'
import { Home, ArrowBack, Lock, Login } from '@mui/icons-material'
import { useAuthStore } from '@store/authStore'

export default function UnauthorizedPage() {
  const navigate = useNavigate()
  const { isAuthenticated } = useAuthStore()

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'background.default',
        p: 3,
      }}
    >
      <Paper
        sx={{
          p: 6,
          maxWidth: 600,
          textAlign: 'center',
          border: '2px solid',
          borderColor: 'error.main',
        }}
      >
        <Lock sx={{ fontSize: 80, color: 'error.main', mb: 3 }} />
        <Typography variant="h4" gutterBottom sx={{ fontWeight: 'bold', mb: 2 }}>
          Access Restricted
        </Typography>
        <Typography variant="body1" color="text.secondary" paragraph sx={{ mb: 4 }}>
          {isAuthenticated
            ? 'You don\'t have permission to access this area. This adventure requires special clearance.'
            : 'This trail is for registered adventurers only. Please sign in to continue your journey.'}
        </Typography>
        <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center', flexWrap: 'wrap' }}>
          <Button
            variant="contained"
            startIcon={<Home />}
            onClick={() => navigate('/')}
            sx={{ textTransform: 'none' }}
          >
            Return to Base Camp
          </Button>
          <Button
            variant="outlined"
            startIcon={<ArrowBack />}
            onClick={() => navigate(-1)}
            sx={{ textTransform: 'none' }}
          >
            Go Back
          </Button>
          {!isAuthenticated && (
            <Button
              variant="contained"
              color="secondary"
              startIcon={<Login />}
              onClick={() => navigate('/login')}
              sx={{ textTransform: 'none' }}
            >
              Sign In
            </Button>
          )}
        </Box>
      </Paper>
    </Box>
  )
}
